import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, Ticket } from "lucide-react";

export default function Redeem() {
  const { code } = useParams();
  const navigate = useNavigate();
  const done = useRef(false);
  const [deal, setDeal] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api.get(`/redeem/${code}`)
      .then(({ data }) => {
        setDeal(data);
        setTimeout(() => navigate(`/business/${data.slug}`), 2200);
      })
      .catch(() => setError(true));
  }, [code, navigate]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <div className="text-center max-w-md">
        {error ? (
          <p className="font-display text-xl text-sam-navy">This deal link is no longer active.</p>
        ) : !deal ? (
          <Loader2 className="h-8 w-8 animate-spin text-sam-crimson mx-auto" />
        ) : (
          <>
            <Ticket className="h-14 w-14 text-sam-crimson mx-auto" />
            <h1 className="mt-4 font-display text-3xl font-extrabold text-sam-navy">{deal.name}</h1>
            {deal.deal_headline && <p className="mt-2 text-lg font-semibold text-sam-crimson">{deal.deal_headline}</p>}
            {deal.deal_details && <p className="mt-1 text-sm text-sam-slate">{deal.deal_details}</p>}
            <p className="mt-5 text-sm text-muted-foreground flex items-center justify-center gap-2"><Loader2 className="h-4 w-4 animate-spin" />Taking you to their page…</p>
          </>
        )}
      </div>
    </div>
  );
}
